import React, { useEffect, useState } from 'react';

import ContactForm from '../../common/ContactForm';

const DownloadApp = ({ t, props }) => {
  // console.log('testing props in download page are----', props);
  useEffect(() => {
    // eslint-disable-next-line
  }, []);

  return (
    <div className="download-app-section">
      <img src="/images/pullman-arrow1.svg" className="pullman-arrow arrow1" alt="" />
      <img src="/images/pullman-arrow2.svg" className="pullman-arrow arrow2" alt="" />
      <img src="/images/pullman-arrow3.svg" className="pullman-arrow arrow3" alt="" />

      <div className="content-container">
        <div className="mobile-screen">
          <img src="/images/home-mobile-app-screen.png" alt="" />
        </div>
        <div className="download-btns">
          {/* <div className="download-label">{t('HOME.COMING_SOON')}</div> */}
          <div
            className="download-info font30 secondary-text bold-text"
            style={{ lineHeight: '1.2' }}
          >
            {t('HOME.DOWNLOAD_OUR_APP_FREE')}
          </div>
          <div className="download-info-small font13">
            {t('HOME.CREATE_YOUR_ACCOUNT_AND_PAY_YOUR_TICKETS_WITH')}
          </div>
          <img src="/images/pullman-pay.svg" className="pullman-pay" alt="" />

          {props &&
            props.home &&
            props.home.metaData &&
            props.home.metaData.social_media_urls &&
            props.home.metaData.social_media_urls.androidUrl ? (
            <div className="store-icon-btns">
              <a href={props.home.metaData.social_media_urls.iosUrl} target="_blank">
                <img src="/images/appstore.svg" className="apple" alt="" />
              </a>
              <a href={props.home.metaData.social_media_urls.androidUrl} target="_blank">
                <img src="/images/googleplay.svg" className="apple" alt="" />
              </a>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const DownloadAndSupport = ({ t, props }) => {
  useEffect(() => {
    // eslint-disable-next-line
  }, []);

  return (
    <div className="download-and-support">
      {/* <DownloadApp t={t} props={props} /> */}
      <div className="home-contact-form">
        <div className='image_wrapper'>
          <img src="/images/contact/contact_banner.webp" alt="" />
        </div>
        <div className="contact_form_container">
          <div className="content-container">
            <ContactForm t={t} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadAndSupport;



// WEBPACK FOOTER //
// ./src/features/home/DownloadAndSupport/DownloadAndSupport.js